import { styled } from "styled-components";
import { mobile } from "storybook/utils/breakpoints";

export const Container = styled.div`
  margin-top: 10px;
`;

export const InputsContainer = styled.div`
  margin-top: 20px;
  min-height: 140px;
  min-width: 320px;
  max-width: 400px;

  .input-group + div {
    margin-top: 10px;
  }

  @media (max-width: ${mobile}px) {
    margin-top: 0;

    > div {
      padding-bottom: 0;
    }
  }
`;

export const CheckList = styled.div`
  > div {
    display: flex;
    padding: 6px 0;
    justify-content: space-between;
    border-bottom: 1px solid #e0e0e0;

    label {
      margin: 0 16px 0 0px;
    }

    && > div {
      display: flex;
      align-items: center;
    }
  }
`;

export const DayTimesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  width: 160px;

  > div:last-child label {
    margin-right: 0;
  }
`;
